import { FC, useEffect } from "react";
import { IArticleStudent, IGetArticleStudents } from "../../../models/statistics.model";
import { useTranslation } from "react-i18next";
import { Table, TableColumnsType } from "antd";
import moment from "moment";
import config from "../../../lib/config";
import DownloadButton from "../../DownloadButton";
import Pagination from "../../common/Pagination";
import useAxios from "../../../hooks/useAxios";
import { getArticleStudents } from "../../../api/statistics.api";
import exportTable from "../../../lib/exportTable";
import useLoader from "../../../hooks/useLoader";

interface IProps {
  data?: IArticleStudent[];
  total?: number;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  params: any;
};

const StatisticsArticleStudentTable: FC<IProps> = ({
  data = [],
  total = 0,
  pageNo,
  setPageNo,
  params,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetArticleStudents>();
  useLoader(isLoading, [error]);

  useEffect(() => {
    if (res) {
      exportTable(
        columns,
        data,
        `Articles(${t('statistics.attendance.Tab2')})_(${moment().format('YYYYMMDD')})`, `${t('statistics.attendance.Tab2')}`,
        [15, 10, 10, 15, 15, 20, 30, 15],
      );
    }
  }, [res]);

  const onExportTable = () => {
    execute(getArticleStudents({
      ...params,
      perPage: 999999999,
      pageNo: 1,
    }));
  }

  const columns: TableColumnsType<IArticleStudent> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusName',
      align: 'center',
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      align: 'center',
    },
    {
      title: t('student.student.column64'),
      dataIndex: 'memberCode',
      align: 'center',
    },
    {
      title: t('sms.send.3'),
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: t('sms.send.4'),
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: 'Post Title',
      dataIndex: 'title',
      align: 'center',
      render: value => {
        return (<div className='text-left ant-table-cell-ellipsis'>{value}</div>);
      }
    },
    {
      title: t('statistics.articles.2'),
      dataIndex: 'postDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      <div className="comm-bx__between">
        <div className="comm-sch_result">
          Total: {<b>{total}</b>}
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            page={pageNo}
            setPage={setPageNo}
            total={total}
          />
        </div>
      </div>    
    </>
  );
};

export default StatisticsArticleStudentTable;